import React, { useState } from 'react';
import dayjs from 'dayjs';
import { Modal, message, Input, DatePicker } from 'antd-v5';
import DropdownSelect from '../DropdownSelect';
import NumberInput from '../NumberInput';
import KioskSlider from '../KioskSlider';
import { postRequest } from '../../../core/apiRequests';

const timeframeList = [
  { label: 'Time Period', value: 'timePeriod' },
  { label: 'Specific Date', value: 'specificDate' },
];

const timeUnitList = [
  { label: 'Days', value: 'days' },
  { label: 'Weeks', value: 'weeks' },
  { label: 'Months', value: 'months' }
];

const intervalObj = {
  DAY: 'days',
  WEEK: 'weeks',
  MONTH: 'months',
};

const EditReminderModal = ({ open, allAssoc, onClose, reminder, setReload }) => {
  const [associate, setAssociate] = useState(reminder.assigned_to);
  const [description, setDescription] = useState(reminder.description);
  const [reminderTimeframe, setReminderTimeframe] = useState(!reminder.repeats ? 'specificDate' : 'timePeriod');
  const [factor, setFactor] = useState(reminder.repeat_scale ?? 1);
  const [timeUnit, setTimeUnit] = useState(intervalObj[reminder.repeat_interval] ?? 'weeks');
  const [repeats, toggleRepeats] = useState(reminder.repeats);
  const [scheduledDate, setScheduledDate] = useState(dayjs(reminder.due_date, 'YYYYMMDD'));

  const saveEdit = async () => {
    const reqObj = {
      params: ['clients', 'editClientReminder'],
      data: {
        associate,
        description,
        reminderTimeframe,
        repeats: reminderTimeframe === 'timePeriod' ? repeats : null,
        interval: factor,
        scale: timeUnit,
        scheduledDate,
        reminderId: reminder.id,
      },
    };
    try {
      await postRequest(reqObj);
      onClose();
      setReload(true);
      message.success('Reminder edited successfully!');
    } catch (error) {
      message.error('There was an error editing the reminder. Please try again.');
      onClose();
      setReload(true);
    }
  };

  return (
    <Modal
      title="Edit Reminder"
      open={open}
      onCancel={onClose}
      onOk={() => saveEdit()}
      okText="Save"
      destroyOnClose
      width={500}
      centered
    >
      <div key="primary" className="align-left m-top-10">
        <span className="dropDownDescriptionText">Assign an Associate</span>
        <DropdownSelect
          classProps="align-left m-top-8"
          options={allAssoc.map(asc => ({
            label: asc.fullName ? asc.fullName : `${asc?.first_name || ''} ${asc?.last_name || ''}`,
            value: asc.id,
          }))}
          placeholder="Select an Associate..."
          value={associate}
          onChange={obj => {
            setAssociate(obj.value);
          }}
        />
      </div>
      <div className="align-left m-top-24">
        <span className="dropDownDescriptionText">Description</span>
        <Input
          id="autoREminderName"
          className="m-top-8"
          value={description}
          onChange={e => setDescription(e.target.value)}
          placeholder="Auto Reminder Name"
        />
      </div>
      <div className="align-left m-top-18">
        <span className="dropDownDescriptionText">When do you want to be reminded?</span>
        <DropdownSelect
          classProps="m-top-8 "
          value={reminderTimeframe}
          placeholder="Select Time Frame"
          options={timeframeList}
          onChange={obj => setReminderTimeframe(obj.value)}
        />
      </div>
      {reminderTimeframe && (
        <div className="m-top-24">
          {reminderTimeframe === 'timePeriod' ? (
            <div>
              <div className="flex-row-spacebetween-nowrap w-100-P">
                <NumberInput value={factor} classProps="w-48-P" onChange={val => setFactor(val)} min={0} />
                <DropdownSelect
                  classProps="w-48-P"
                  placeholder="Choose an opportunity..."
                  value={timeUnit}
                  options={timeUnitList}
                  onChange={obj => setTimeUnit(obj.value)}
                />
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  textAlign: 'left',
                }}
                className="m-top-11"
              >
                <KioskSlider value={repeats} onChange={() => toggleRepeats(!repeats)} />
                <span className="m-left-10 fw-500 " style={{ marginTop: '2px' }}>
                  Repeats
                </span>
              </div>
            </div>
          ) : (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'left',
                width: '100%',
                textAlign: 'left',
              }}
            >
              <span className="dropDownDescriptionText">Select a Date</span>
              <DatePicker
                value={scheduledDate}
                onChange={date => setScheduledDate(date)}
                style={{ width: '100%', marginTop: '8px' }}
              />
            </div>
          )}
        </div>
      )}
    </Modal>
  );
};

export default EditReminderModal;
